import {Component, OnInit} from '@angular/core';
import {ServiceService} from '../../services/service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { JwtAuthService } from '../../services/auth/jwt-auth.service';
import { DomSanitizer} from '@angular/platform-browser';
import { NgxSpinnerService } from "ngx-spinner";
import {AddressesPopupComponent} from './addresses-popup/addresses-popup.component'
import {TdcPopupComponent} from './tdc-popup/tdc-popup.component'
import {FacPopupComponent} from './fac-popup/fac-popup.component'
import {TermsPopupComponent} from './terms-popup/terms-popup.component'
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import{GoogleAnalyticsService} from '../../google-analytics.service';
import { environment } from '../../../environments/environment';



@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit {

  responseForm : any;
  form: any;
  error = '';
  info = '';
  url ='';
  develop = '';
  email : any = true;
  login : any = false;
  signinData : any = {};
  customer:any = -1;
  username:any;
  addres:any;
  password:any;
  id_adress: any = null;
  id_tdc:any = null;
  id_service:any;
  success : any = false;
  option:any;
  id_hasplan:any;
  id_3dshasplan: any;
  customer_email:any;
  provinces: any[]= [] ;
  corregimientos: any[]= [] ;
  status_tdc : any;
  id_tdc_corer : any;
  description : any;
  tdc:any;
  partner : any;

  confirmation : any = false;

  tarjetas: any = [];

  userLogged : any = false;
  userRegister : any = false;

  lastTdc : any;


  title = 'united-coffee-landing';
  
  plans = [
    {
      description: 'plan-one-desc',
      image: '../../../assets/images/plan.svg',
      title: 'plan-one-name'
    },
    {
      description: 'plan-two-desc',
      image: '../../../assets/images/plan-2.svg',
      title: 'plan-two-name'
    }
  ];
  plan: any = {};

  constructor(private call : ServiceService, 
    private googleAnalyticsService: GoogleAnalyticsService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private sanitizer: DomSanitizer,
		private activatedRoute: ActivatedRoute, private jwtAuth: JwtAuthService) {
  }

  ngOnInit(): void {
    //this.responseForm = '<HTML><BODY><FORM ID=\"frmHtmlCheckout\" NAME=\"frmHtmlCheckout\" METHOD=\"POST\" ACTION=\"https://marlin.firstatlanticcommerce.com/SENTRY/PaymentGateway/Application/DirectAuthLink.aspx\">\r\n<NOSCRIPT>\r\n<BR><BR>\r\n<H1 ALIGN=\"center\">Processing your Transaction</H1>\r\n<H2 ALIGN=\"center\">JavaScript is currently disabled or is not supported by your browser.</H2><BR>\r\n<H3 ALIGN=\"center\">Please click on the Submit button to continue processing.</H3>\r\n<INPUT TYPE=\"submit\" value=\"Submit\" ID=\"submit\" NAME=\"submit\">\r\n</NOSCRIPT>\r\n<INPUT TYPE=\"hidden\" NAME=\"Version\" ID=\"Version\" VALUE=\"2.0.0\">\r\n<INPUT TYPE=\"hidden\" NAME=\"AcqID\" ID=\"AcqID\" VALUE=\"464748\"> \r\n<INPUT TYPE=\"hidden\" NAME=\"MerID\" ID=\"MerID\" VALUE=\"88803239\">\r\n<INPUT TYPE=\"hidden\" NAME=\"PurchaseAmt\" ID=\"PurchaseAmt\" VALUE=\"000000010000\">\r\n<INPUT TYPE=\"hidden\" NAME=\"PurchaseCurrency\" ID=\"PurchaseCurrency\" VALUE=\"840\">\r\n<INPUT TYPE=\"hidden\" NAME=\"PurchaseCurrencyExponent\" ID=\"PurchaseCurrencyExponent\" VALUE=\"2\">\r\n<INPUT TYPE=\"hidden\" NAME=\"OrderID\" ID=\"OrderID\" VALUE=\"3453453344345\">\r\n<INPUT TYPE=\"hidden\" NAME=\"CardNo\" ID=\"CardNo\" VALUE=\"4111111111111111\">\r\n<INPUT TYPE=\"hidden\" NAME=\"CardExpDate\" ID=\"CardExpDate\" VALUE=\"0323\">\r\n<INPUT TYPE=\"hidden\" NAME=\"SignatureMethod\" ID=\"SignatureMethod\" VALUE=\"SHA1\">\r\n<INPUT TYPE=\"hidden\" NAME=\"Signature\" ID=\"Signature\" VALUE=\"fV3WucPWwhWWpLcanu6Ysql6gKs=\">\r\n<INPUT TYPE=\"hidden\" NAME=\"CaptureFlag\" ID=\"CaptureFlag\" VALUE=\"M\">\r\n<INPUT TYPE=\"hidden\" NAME=\"MerRespURL\" ID=\"MerRespURL\" VALUE=\"https://dev.hecbill.hecticus.com/billcentrix\"> \r\n<INPUT TYPE=\"hidden\" NAME=\"CustomData\" ID=\"CustomData\" VALUE=\"\"> \r\n<INPUT TYPE=\"hidden\" NAME=\"InterfaceCode\" ID=\"InterfaceCode\" VALUE=\"FACPG2.WCF\">\r\n</FORM>\r\n<SCRIPT LANGUAGE=\"JavaScript\">\r\nCheckout();\r\nfunction Checkout() {\r\n  document.frmHtmlCheckout.action = \"https://marlin.firstatlanticcommerce.com/SENTRY/PaymentGateway/Application/DirectAuthLink.aspx\";\r\n  document.frmHtmlCheckout.submit();\r\n}\r\n</SCRIPT>\r\n</BODY></HTML>\r\n';
   
    this.form = new FormGroup({
      email: new FormControl('', [Validators.required,Validators.email]),
      name: new FormControl('', Validators.required),
      adress: new FormControl('', Validators.required),
      name_tdc : new FormControl('', Validators.required),
      number_tdc: new FormControl('', Validators.required),
      month: new FormControl('', Validators.required),
      year: new FormControl('', Validators.required),
      ccv: new FormControl('', Validators.required),
      url : new FormControl(this.router.url, Validators.required),
      province : new FormControl('', Validators.required),
      corregimiento : new FormControl('', Validators.required)
    });

   // this.call.GetProvinces().subscribe(provinces =>{
    this.call.getService(Number(localStorage.getItem("service"))).subscribe(service =>{
     
       this.call.get(this.call.HOST + "/partner/" + service.partner_id).subscribe(partner =>{
       
        this.provinces = partner.result.provinces;
       });

    });
  

    // ESTO LO HACEMOS PARA COMPROBAR SI EL USUARIO SE ENCUENTRA LOGEADO
    if(localStorage.getItem('currentData') != undefined){
      this.userLogged = true;
      let data : any = localStorage.getItem('currentData');
      this.customer = JSON.parse(data).customer
      this.form.controls["email"].setValue(JSON.parse(data).user.email_user);

      /*this.call.getLastConfiguration(this.customer).subscribe(response =>{
          // COLOCAMOS LA ULTIMA DIRECCION DEL USUARIO
          if(response.adress.name != undefined){
            this.id_adress = response.adress.id;
            this.form.controls["name"].setValue(response.adress.name);
            this.form.controls["adress"].setValue(response.adress.adress);
          }
        
          // OBTENEMOS LAS TARJETAS DEL CLIENTE PARA VALIDAR QUE NO INGRESE DE NUEVO UNA YA REGISTRADA
          this.call.findByCustomer(this.customer).subscribe(params =>{
            if(params['result'] != null){
              for( let tdc of params['result']){
                // COMPARAMOS EL TOKEN DE LAS TDC CON EL TOKEN DE LA ULTIMA TDC DEL USUARIO
                if(response.tdc.token_creditCardToken != undefined && response.tdc.token_creditCardToken == tdc.tokenCreditCard){
                  this.id_tdc = response.tdc.id;
                  this.form.controls["name_tdc"].setValue(tdc.creditCard.nameHolderCreditCard);
                  this.form.controls["number_tdc"].setValue(tdc.creditCard.maskCreditCard);
                  this.form.controls["month"].setValue(tdc.creditCard.yearMonthExpiration.substr(tdc.creditCard.yearMonthExpiration.length-2));
                  this.form.controls["year"].setValue(tdc.creditCard.expYearCreditCard);
                }
                this.tarjetas.push(tdc.creditCard.maskCreditCard)
              }
            }else{
              console.log("NO TDC")
            }
        });
      })*/    
    
    }

      // TOMAMOS LA OPCION QUE ELIGIO EL CLIENTE
      this.activatedRoute.queryParams.subscribe(queryParams =>{
      if(queryParams.option!=null){
        this.option = queryParams.option;
      }else{
        this.option = null;
      }
      this.activatedRoute.params.subscribe(params =>{
      this.id_service = localStorage.getItem("service");
      let id_plan : any = localStorage.getItem("plan");
      this.call.getPlan(id_plan).subscribe(plan=>{

        this.call.getService(Number(localStorage.getItem("service"))).subscribe(response =>{
          this.spinner.hide();
              this.partner = response.partner_id;
          }, err =>{
            this.spinner.hide();
            console.log(err);
        });



        this.plan = plan;

        this.description = plan.frecuency.name_frecuency + " $" + plan.enrollmentCost_plan;

        // TODO - ESTA BUSQUEDA EN CASO DE APROVAR LA CARGA DE ARRIBA LA DE LAS DIRECCIONES Y TARJETA PREFERIDA DEL USUARIO
        // HAY QUE QUITARLA DE ESTA SECCION PORQUE YA SE HACE ARRIBA
        // OBTENEMOS LAS TARJETAS DEL CLIENTE PARA VALIDAR QUE NO INGRESE DE NUEVO UNA YA REGISTRADA
        if(this.userLogged){
          this.call.findByCustomerInCorer(this.customer).subscribe(params =>{
            if(params['result'] != null){
              for( let tdc of params['result']){
                this.tarjetas.push(tdc.creditCard.maskCreditCard)
              }
            }else{
              console.log("NO TDC")
            }
        });
        }
        
        // HASTA AQUI

        
        // COMPROBAMOS QUE EXISTA EL QUERY PARAMS QUE CONTROLA EL LOGIN DESDE ESTA PANTALLA DE CHECKOUT
        this.activatedRoute.queryParams.subscribe(queryParams =>{
          if(queryParams.subscription != undefined && localStorage.getItem("checkout") != null){

            // CARGAMOS LA INFORMACION EN PANTALLA
          
            let data : any = localStorage.getItem("checkout");
            let json = JSON.parse(data);
            this.sendMessage()

            this.form.controls["email"].setValue(json.email);
            this.form.controls["name"].setValue(json.name);
            this.form.controls["adress"].setValue(json.adress);
            this.form.controls["name_tdc"].setValue(json.name_tdc);
            this.form.controls["number_tdc"].setValue(json.number_tdc);
            this.form.controls["month"].setValue(json.month);
            this.form.controls["year"].setValue(json.year);
            this.form.controls["ccv"].setValue(json.ccv);
            this.form.controls["province"].setValue(json.province);
            this.form.controls["corregimiento"].setValue(json.corregimiento);
            this.onProvinceChargeChange(json.province);
           
          }
        })

      })    
    });
   })
  }

  checkout(){

    this.spinner.show();

    if(this.error){
      this.error = '';
    }
    const data = this.form.value;

    // ESTO PARA CUANDO ESTA INTENTANDO SUSCRIBIRSE SIN HABER INICIADO SESION
    if(!this.userLogged){
       // BUSCAMOS EL EMAIL
      this.call.getAuth(data.email, this.partner).subscribe(response =>{
        
        this.spinner.hide();
        // AQUI LO ENCONTRO ENTONCES MOSTRAMOS PARA INTRODUCIR EL PASSWORD
        
        this.info = "Ya posees una cuenta registrada, por favor inicia sesion ";
        data.plan = this.plan.id;
        // GUARDAMOS EL OBJETO QUE TIENE LA INFORMACION CON LA COMPRA
        localStorage.setItem('checkout',JSON.stringify(data));
        this.login = true;
        return;
      
  
        }, err =>{
          // SI ENTRA POR AQUI ES QUE NO LO ENCONTRO REGISTRADO POR LO QUE MOSTRAMOS PANTALLA DE REGISTRO
          this.login = false;
          this.sendSingUp(data);
        })
      }else{
        this.sendCheckout(data)
      } 


    }

    sendCheckout(data:any){

          // ESTE ES EL PROECSO PARA REALIZAR LA SUSCRIPCION
          let tdc : any = {};
          let adress : any = {};
          let send : any = {};

      
          // EN CASO DE HABER SELECCIONADO UNA DE LAS TARJETAS REGISTRADAS
         
          if(this.id_tdc != null ){
          tdc.id = this.id_tdc;
          tdc.status = this.status_tdc;
          tdc.idcorer = this.id_tdc_corer;
          tdc.ccv = data.ccv;
          /* TODO - VALIDAR CON ESTO LA VERACIDAD DEL TOKEN
            this.creditCardService.findTdcById(this.IDcustomer,id).subscribe(tdc => {
            //Se guarda la descripcion del estado en la columna correspondiente
            this.creditCardService.delete(this.IDcustomer,tdc['result'].id).subscribe(params => {
              this.ngOnInit();
          }, (err) => {
              this.notificationService.error("No se pudo cambiar el estado de la tarjeta " + mask + ". Verifique que no se encuentre asociada a un plan activo");
          });
          }, (err) => this.notificationService.error(err) );
          */

          }else{  


          // HACEMOS ESTO PARA VALIDAR QUE NO ESTE INGRESANDO UNA TARJETA YA REGISTRADA
          // let found = false;

          // for(let tdc of this.tarjetas){
          //   if(tdc.substr(tdc.length-4) ==  data.number_tdc.toString().substr(data.number_tdc.toString().length-4) ){
          //     found = true;
          //   }
          // }
       
          // EN CASO DE NO EXISTIR LA TARJETA
          // if(!found){
          tdc.numberCreditCard = data.number_tdc;
          tdc.nameHolderCreditCard = data.name_tdc;
          tdc.expMonthCreditCard = data.month;
          tdc.expYearCreditCard = data.year;
          tdc.ccv = data.ccv;
          // }else{  // EN CASO DE HABERLA ENCONTRADO
          //   this.error = 'La tarjeta ya se encuentra registrada';
          //   this.spinner.hide();
          //   return;
          // }

        }

        this.tdc = 'XXXXXXXXXXX' + data.number_tdc.substring(data.number_tdc.length - 4);

          // EN CASO DE HABER SELECCIONADO UNA DE LAS DIRECCIONES REGISTRADAS
          if(this.id_adress != null){
            adress.id = this.id_adress;
          }else{
              // en caso de no existir la direccion entonces
              adress.name = data.name;
              adress.adress = data.adress;
              adress.province = data.province;
              adress.corregimiento = data.corregimiento;
          }
          // armamos el objeto que va a ir al backend
          if(this.option!=null){
            send = {url : data.url, creditcard:tdc, adress:adress, customer:this.customer, option:this.option, service : this.id_service, plan : this.plan.id, param : 4}
          }else{
            send = {url : data.url, creditcard:tdc, adress:adress, customer:this.customer, service : this.id_service, plan : this.plan.id, param : 4}
          }
          //console.log(send);
          // TODO - ESTO HAY QUE CAMBIARLO CUANDO SE TENGA EL OTRO ENDPOINT
          this.call.sendSucribe(send).subscribe(response=>{
              // llevamos al cliente a sus suscripciones
             // REMOVEMOS EL OBJETO DE MEMORIA
             localStorage.removeItem('checkout');
             this.spinner.hide();

             if(response.htmlFormData){
              
              this.id_3dshasplan = response.id;
               //this.responseForm = response.htmlFormData; 

               let dialogRef: MatDialogRef<any> = this.dialog.open(FacPopupComponent, {
                width: '50%',
                height:'90%',
                disableClose: true,
                data: { form: this.sanitizer.bypassSecurityTrustHtml(response.htmlFormData), id: response.id }
              })
              dialogRef.afterClosed()
                .subscribe(res => {
                  this.myLoadEvent();
                })

               //console.log(response.htmlFormData)    
               //this.formPopup(response.htmlFormData);        
             }else{ 

              this.id_hasplan = response.result;
              this.customer_email = this.form.value.email;
              
              // ENVIAMOS EVENTO DE COMPRA A GOOGLE ANALYTICS SOLO SI ESTAMOS EN PRODUCCION
              if(environment.production){
                let id_plan : any = localStorage.getItem("plan");
                this
                .googleAnalyticsService
                .eventEmitterCheckout("purchase", "ecommerce", "click", "Suscribirse", id_plan,this.option,this.customer);
              }
              
              if(this.userLogged){
                this.sendMessage2();
                this.spinner.hide();
                this.signinData = true;
                this.confirmation = true;
              }else{
                this.signIn(this.username, this.password, this.id_service, this.customer, this.partner);
              } 
             }
            }, (err) =>{
              console.log(err);

              // AGREGAMOS ESTO PARA HACER LOGIN EN CASO DE QUE NO ESTE LOGEADO EL CUSTOMER
              if(!this.userLogged){
                this.MakesignIn(this.username, this.password, this.id_service, this.customer, this.partner);
              }else{
                this.spinner.hide();
              }

              this.error = err;
              
            })
      
          
          // AQUI DEBERIA ENVIAR EL COBRO 

    }

    goLogin(){
      this.router.navigate(['/' + localStorage.getItem("service") + '/login'], { queryParams: { subscription: true }, queryParamsHandling: 'merge' });
    }


    sendSingUp(data:any) {

      var name = this.form.value.name;

      this.signinData.name_customer = name.split(" ")[0];
      if(name.split(" ").length > 1){
        this.signinData.lastName_customer = name.split(" ")[1];
      }else{
        this.signinData.lastName_customer = name.split(" ")[0]
      }
      
      this.signinData.identifier_customer = this.form.value.email  ;
      this.signinData.adress_customer = this.form.value.adress  ;
      this.signinData.email_customer = this.form.value.email  ;
      this.signinData.province = this.form.value.province;
      this.signinData.corregimiento = this.form.value.corregimiento;
      
      // COLOCAMOS ESTATUS E ACTIVO AL CLIENTE
      this.signinData.status_customer = 1;
      // COMO ES CLIENTE DE LANDING, SU EMAIL SERA EL CODIGO DEL CLIENTE
      this.signinData.code_customer = this.form.value.email;

      


     // console.log(this.signinData);
  
      this.activatedRoute.params.subscribe(params =>{
  
        this.call.getService(params["service"]).subscribe(service =>{
         
          // ESTE ES EL PARTNER QUE ES DUE*O DEL PLAN Y SERVICIO
          this.signinData.partner = {id:service.partner_id};
          this.signinData.service = Number(params["service"]);
         // REGISTRAMOS AL CUSTOMER
         //console.log(this.signinData)
          this.call.registryCustomer(this.signinData).subscribe(result =>{
            // TOMAMOS EL ID DEL CUSTOMER QUE SE ACABA DE GENERAR
            this.customer = result.customer.id;
            // MOSTRAMOS MENSAJE DE INFORMACION
            this.password = result.accessToken;
            this.username = result.customer.email_customer;
            this.id_adress = result.address;
            this.sendCheckout(data);

          }, err => {
            //this.notificationService.error(err);
            this.spinner.hide();
            console.log(err);
            this.error = err;
          })
  
        });
     
        
      }); 
  
    }


    signIn(username:any,password:any,service:any, customer:any, partner : any){
      this.jwtAuth.signin(username , password, partner)
      .subscribe(response => {
        
        let data : any = localStorage.getItem('currentData');
        if(data == null){
          this.signIn(username,password,service,customer, partner);
        }else{
          this.sendMessage();
          this.sendMessage2();
          this.spinner.hide();
          this.userLogged = true;
          this.confirmation = true;
        }
        
  
      }, err => {
        console.log(err);
        this.error = err;
      })
    }


    MakesignIn(username:any,password:any,service:any, customer:any, partner : any){
      this.jwtAuth.signin(username , password, partner)
      .subscribe(response => {
        
        let data : any = localStorage.getItem('currentData');
        if(data == null){
          this.MakesignIn(username,password,service,customer, partner);
        }else{
          this.sendMessage();
          this.spinner.hide();
          this.userLogged = true;
          
        }
        
  
      }, err => {
        console.log(err);
        this.error = err;
      })
    }

    sendMessage(): void {
      // send message to subscribers via observable subject
      this.call.sendUpdate('Message from Sender Component to Receiver Component!');
    } 

    sendMessage2(): void {
      // send message to subscribers via observable subject
      this.call.sendUpdate2('Message from Sender Component to Receiver Component!');
    } 

    changeTDC(){
      // Borramos la TDC  que haya seleccionado previamente
      delete this.id_tdc;
      delete this.status_tdc;
    }


    formPopup(data: any) {
    
      let dialogRef: MatDialogRef<any> = this.dialog.open(FacPopupComponent, {
        width: '100%',
        height:'80%',
        disableClose: true,
        data: { form: data }
      })
      dialogRef.afterClosed()
        .subscribe(res => {
          console.log("TERMINO EL POPUP");
          console.log(res)
          if(!res) {
            // If user press cancel
            return;
          }

          this.myLoadEvent();
          
        })
    }


    


    tdcPopUp(data: any = {}) {
    
      let dialogRef: MatDialogRef<any> = this.dialog.open(TdcPopupComponent, {
        width: '100%',
        height:'80%',
        disableClose: true,
        data: { customer: this.customer }
      })
      dialogRef.afterClosed()
        .subscribe(res => {
          if(!res) {
            // If user press cancel
            return;
          }
          //console.log(res);
          this.id_tdc = res.token;
          this.status_tdc = res.status;
          this.id_tdc_corer = res.id;
          this.form.controls["name_tdc"].setValue(res.nameHolderCreditCard);
          this.form.controls["number_tdc"].setValue(res.maskCreditCard);
          this.form.controls["month"].setValue(res.yearMonthExpiration.substr(res.yearMonthExpiration.length-2));
          this.form.controls["year"].setValue(res.expYearCreditCard.substr(res.expYearCreditCard.length-2));
         
        })
    }

    addressesPopUp(data: any = {}) {
    
      let dialogRef: MatDialogRef<any> = this.dialog.open(AddressesPopupComponent, {
        width: '100%',
        height:'80%',
        disableClose: true,
        data: { customer: this.customer }
      })
      dialogRef.afterClosed()
        .subscribe(res => {
          if(!res) {
            // If user press cancel
            return;
          }
          // TOMAMOS LA INFORMACION DE LA DIRECCION SELECCIONADA
          //console.log(res);
          this.id_adress = res.id;
          this.form.controls["name"].setValue(res.name + " " + res.lastname);
          this.form.controls["adress"].setValue(res.adress);
          this.form.controls["province"].setValue(res.province.id);
          this.form.controls["corregimiento"].setValue(res.corregimiento.id);

          this.onProvinceChargeChange(res.province.id);
         
        })
    }

    termsPopUp(data: any = {}) {
    
      let dialogRef: MatDialogRef<any> = this.dialog.open(TermsPopupComponent, {
        width: '100%',
        height:'60%',
        disableClose: true,
        data: { terms: this.plan.terms }
      })
      dialogRef.afterClosed()
        .subscribe(res => {
          if(!res) {
            // If user press cancel
            return;
          }
        })
    }

    onlyNumberKey(event : any){
      return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
    }

    goSubs(){
      this.router.navigateByUrl("/" + this.id_service + "/suscriptions");  
    }

    onProvinceChange(province:any){
      this.corregimientos = [];
      this.corregimientos = this.provinces[this.provinces.findIndex(t => t.id == province)].corregimientos;
      this.corregimientos.sort((a,b) =>  (a.name > b.name ? 1 : -1));

    }

    onProvinceChargeChange(province:any){

      if(this.id_adress != null){
        this.id_adress == null;
      }

      this.corregimientos = [];
      this.corregimientos = this.provinces[this.provinces.findIndex(t => t.id == province)].corregimientos;
      this.corregimientos.sort((a,b) =>  (a.name > b.name ? 1 : -1));
    }

    onCorregimientoChange(corregimiento:any){

      if(this.id_adress != null){
        delete this.id_adress;
      }

    }

    myLoadEvent(){

     this.call.getHasPlan(this.id_3dshasplan).subscribe(chp =>{

      this.spinner.hide();
  
       if(chp.status_customerPlan  != 4){
          if(chp.status_customerPlan == 1 ){ // ESTO ES QUE SE COBRO Y TODO BIEN CON LA SUSCRIPCION ESTA ACTIVA
            this.id_hasplan = this.id_3dshasplan;
            this.customer_email = chp.customer.email_customer;
            // ENVIAMOS EVENTO DE COMPRA A GOOGLE ANALYTICS SOLO SI ESTAMOS EN PRODUCCION
            if(environment.production){
              let id_plan : any = localStorage.getItem("plan");
              this
              .googleAnalyticsService
              .eventEmitterCheckout("purchase", "ecommerce", "click", "Suscribirse", id_plan,this.option,chp.customer.id);
            }
            
            if(this.userLogged){
              this.sendMessage2();
              this.spinner.hide();
              this.signinData = true;
              this.confirmation = true;
            }else{
              this.signIn(this.username, this.password, this.id_service, this.customer, this.partner);
            } 

        }else{
          this.error = "Su pago fue rechazado por el banco";
          // AGREGAMOS ESTO PARA HACER LOGIN EN CASO DE QUE NO ESTE LOGEADO EL CUSTOMER
          if(!this.userLogged){
            this.MakesignIn(this.username, this.password, this.id_service, this.customer, this.partner);
          }else{
            this.spinner.hide();
          }
          
        }
        
       }
       
     })
    }
  
  
  
    
}
